import React from 'react';

import { GenericP, GenericSpan } from 'commonStyles';
import { ListWrapper } from '../Filter/FilterStyles';
import { T_AND_C_CONFIG, T_AND_C_TEXT } from '../../../../config';
import { APPLICATION_CONSTANTS } from 'AppConstants';

const TermsAndConditions = ({ data = [], isPopUp = false }) => {
	const cssProps = isPopUp ? APPLICATION_CONSTANTS.POPUP : APPLICATION_CONSTANTS.OTHERS;
	const { heading = {}, wrapper = {}, listing = {} } = T_AND_C_CONFIG[cssProps];
	return (
		<>
			<GenericP {...heading}>{T_AND_C_TEXT}</GenericP>
			<ListWrapper as='ul' {...wrapper}>
				{data.map((item, index)=>(
					<GenericSpan as='li' key={index} {...listing}>{item}</GenericSpan>))}
			</ListWrapper>
		</>
	);
};

export default TermsAndConditions;
